import React, { useState, useCallback, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
// import axios from "axios";
import { fetchDeliveryInfo } from "../store/action/deliveryActions";
import {
  FaMapMarkerAlt,
  FaShoppingBag,
  FaCreditCard,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
  FaStore,
} from "react-icons/fa";
import { VscDebugBreakpointUnsupported } from "react-icons/vsc";
import { BiSupport } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../home/Loader";
import Infor from "./Infor";
import Cart from "./Cart";

import "./checkout.css";
import PageTitle from "../store/PageTitle";
import PostHog from "posthog-js";

const serverUrl = process.env.REACT_APP_SERVER_URL;
// API Service Module
const DeliveryService = {
  fetchZones: async () => {
    const response = await fetch(`${serverUrl}/delivery-within`);
    if (!response.ok) throw new Error("Failed to fetch zones");
    return await response.json();
  },

  fetchOutSideRates: async () => {
    const response = await fetch(`${serverUrl}/delivery-outside`);
    if (!response.ok) throw new Error("Failed to fetch outside Lusaka rates");
    return await response.json();
  },

  fetchStores: async () => {
    // Mock data for stores
    const mockStores = [
      { id: 1, name: "City Gamers Arcades Mall", address: "Arcades Mall" },
      { id: 2, name: "City Gamers Novela Mall", address: "Novela Mall" },
      { id: 3, name: "City Gamers Nkwazi RD", address: "Nkwazi RD" },
    ];

    return mockStores;
  },

  saveDeliveryInfo: async (payload) => {
    const response = await fetch(`${serverUrl}/users-delivery-infor`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("Failed to save information");
    return await response.json();
  },

  savePickupInfo: async (payload) => {
    const response = await fetch(`${serverUrl}/users-delivery-infor`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("Failed to save pickup info");
    return await response.json();
  },

  calculateDeliveryFee: async (coordinates) => {
    const response = await fetch(`${serverUrl}/calculate-fee`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(coordinates),
    });
    if (!response.ok) throw new Error("Failed to calculate fee");
    return await response.json();
  },
};

const ZoneDropdown = ({
  zones,
  selectedZone,
  onSelect,
  isEditing,
  cartValue,
  applicableRate,
  state,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  // const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // LOCATION SEARCH USING PHOTON API
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const searchLocation = async (value) => {
    setQuery(value);

    if (value.length < 3) {
      setResults([]);
      return;
    }

    const response = await fetch(
      `https://photon.komoot.io/api/?q=${encodeURIComponent(value)}&countrycode=ZM`,
    );

    const data = await response.json();

    setResults(data.features);
  };

  //CALCULATE DELIVERY FEE BASED ON SELECTED ZONE

  const CENTRAL_LOCATION = {
    latitude: -15.4167,
    longitude: 28.2833,
  };

  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Earth's radius in km

    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  }

  // User Outside Lusaka: Use selected location for distance calculation

  // cartValue and applicableRate are passed from the parent Checkout component.
  const LUSAKA_MAX_RADIUS_KM = 30;

  function isOutsideLusaka(photonProperties, distanceFromCenter) {
    const { city, county, state, country } = photonProperties;

    // Check geographic metadata from Photon
    const locationText = [city, county, state, country]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    const mentionsLusaka =
      locationText.includes("lusaka") ||
      locationText.includes("lusaka province");

    // If Photon says it's not in Lusaka, or distance exceeds threshold
    if (!mentionsLusaka || distanceFromCenter > LUSAKA_MAX_RADIUS_KM) {
      return true;
    }

    return false;
  }

  const currentDistance = selectedLocation
    ? calculateDistance(
        CENTRAL_LOCATION.latitude,
        CENTRAL_LOCATION.longitude,
        selectedLocation.latitude,
        selectedLocation.longitude,
      )
    : Number(selectedZone?.distance) || 0;

  if (selectedLocation) {
    console.log(`Distance: ${currentDistance.toFixed(2)} km`);
  }

  const selectedDistance = Number(
    selectedZone?.distance || currentDistance || 0,
  );

  const outsideLusakaRates = state.outsideRates?.data?.[0] ?? null;
  console.log("Outside Lusaka Rates from state:", outsideLusakaRates);

  // calculate delivery fee based on whether location is outside Lusaka or not
  function getValueSurcharge(cartValue) {
    console.log("rates:", outsideLusakaRates?.outsideRates);

    const rates = outsideLusakaRates?.outsideRates || [];

    const match = rates.find((rate) => cartValue <= Number(rate.under));

    console.log("match:", match);

    return match ? Number(match.price) : 0;
  }

  console.log(
    "cart value in getValueSurcharge :",
    cartValue,
    getValueSurcharge(cartValue),
  );

  const OUTSIDE_LUSAKA_RATE_PER_KM = Number(outsideLusakaRates?.out_lsk_rate);
  console.log("Outside Lusaka Rate per KM:", OUTSIDE_LUSAKA_RATE_PER_KM);

  function calculateOutsideLusakaFee(distanceKm, cartValue) {
    const distanceFee = distanceKm * OUTSIDE_LUSAKA_RATE_PER_KM;
    const valueSurcharge = getValueSurcharge(cartValue);
    return Number((distanceFee + valueSurcharge).toFixed(2));
  }

  const deliveryFee = (() => {
    if (selectedLocation?.isOutsideLusaka) {
      return calculateOutsideLusakaFee(currentDistance, cartValue);
    }

    // Fixed zone fee exists
    if (
      selectedZone?.fixedDeliveryFee !== undefined &&
      selectedZone?.fixedDeliveryFee !== null
    ) {
      return selectedZone.fixedDeliveryFee;
    }

    // Calculate dynamically
    return selectedDistance * applicableRate;
  })();

  return (
    <div className="zone-dropdown-container" ref={dropdownRef}>
      <PageTitle title="Checkout" />
      <div
        className="zone-dropdown-header"
        onClick={() => isEditing && setIsOpen(!isOpen)}
      >
        <div className="selected-zone">
          {selectedZone ? (
            <>
              <span className="zone-name">{selectedZone.name}</span>
              <span className="zone-fee">
                K{deliveryFee !== null ? deliveryFee.toFixed(2) : "N/A"}
              </span>
            </>
          ) : (
            <span className="placeholder">Select a delivery zone</span>
          )}
        </div>
        {isEditing && (
          <div className="dropdown-icon">
            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="dropdown-content">
          <div className="search-container-zone">
            <FaSearch className="search-zone" />
            <input
              type="text"
              placeholder="Search zones..."
              value={query}
              onChange={(e) => searchLocation(e.target.value)}
              autoFocus
            />
          </div>

          <div className="zones-list">
            {results.length > 0 && (
              <div className="suggestions-box">
                {results.map((item, index) => (
                  <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => {
                      const [lon, lat] = item.geometry.coordinates;
                      const distanceFromCenter = calculateDistance(
                        CENTRAL_LOCATION.latitude,
                        CENTRAL_LOCATION.longitude,
                        lat,
                        lon,
                      );

                      const outsideLusaka = isOutsideLusaka(
                        item.properties,
                        distanceFromCenter,
                      );

                      let selected;

                      if (outsideLusaka) {
                        const fee = calculateOutsideLusakaFee(
                          distanceFromCenter,
                          cartValue,
                        ); // 👈 pass your cartValue here
                        selected = {
                          name: item.properties.name,
                          distance: Number(distanceFromCenter.toFixed(2)),
                          delivery_fee: fee,
                          isOutsideLusaka: true,
                          requiresThirdPartyShipping: true,
                          applicableRate,
                        };
                      } else {
                        const deliveryFee =
                          parseFloat(distanceFromCenter.toFixed(2)) *
                          applicableRate;
                        selected = {
                          name: item.properties.name,
                          distance: Number(distanceFromCenter.toFixed(2)),
                          delivery_fee: Number(deliveryFee.toFixed(2)),
                          isOutsideLusaka: false,
                          applicableRate,
                        };
                      }

                      setQuery(item.properties.name);
                      setSelectedLocation({
                        latitude: lat,
                        longitude: lon,
                        name: item.properties.name,
                        isOutsideLusaka: outsideLusaka,
                      });

                      setResults([]);
                      if (onSelect) onSelect(selected);
                      setIsOpen(false);
                    }}
                  >
                    {item.properties.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const StoreDropdown = ({ stores, selectedStore, onSelect, isEditing }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  const filteredStores = stores.filter((store) =>
    store.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="zone-dropdown-container" ref={dropdownRef}>
      <div
        className="zone-dropdown-header"
        onClick={() => isEditing && setIsOpen(!isOpen)}
      >
        <div className="selected-zone">
          {selectedStore ? (
            <>
              <span className="zone-name">{selectedStore.name}</span>
              <span className="zone-fee">{selectedStore.address}</span>
            </>
          ) : (
            <span className="placeholder">Select a store for pickup</span>
          )}
        </div>
        {isEditing && (
          <div className="dropdown-icon">
            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="dropdown-content">
          <div className="search-container-zone">
            <FaSearch className="search-zone" />
            <input
              type="text"
              placeholder="Search stores..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>

          <div className="zones-list">
            {filteredStores.map((store) => (
              <div
                key={store.id}
                className="zone-item"
                onClick={() => onSelect(store)}
              >
                <span className="zone-name">{store.name}</span>
                <span className="zone-fee">{store.address}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const Checkout = ({ isCartOpen, closeCart, closeCartRef }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth.user?.id);
  const savedAddress = useSelector((state) => state.deli.deliveryInfo);
  const { checkoutItems, totalAmount } = useSelector((state) => state.checkout);

  const [formData, setFormData] = useState({
    street: "",
    fullName: "",
    contact: "",
    email: "",
  });

  console.log("Checkout Items from Redux:", checkoutItems);

  const [state, setState] = useState({
    zones: [],
    stores: [],
    selectedZone: null,
    selectedStore: null,
    isEditing: false,
    isLoading: false,
    geoEnabled: false,
    location: null,
    deliveryInfo: null,
    error: null,
    deliveryMethod: savedAddress?.deliveryMethod || "delivery", //  set based on savedAddress
  });

  const cartValue = totalAmount || 0;
  const lskRateSettings = state.zones?.data?.[0] ?? null;

  const applicableRate = (() => {
    if (!lskRateSettings) return 10;
    const lskGreater = Number(lskRateSettings.lsk_greater ?? Infinity);
    const lskPrice = Number(lskRateSettings.lsk_price ?? 0);
    const lskRate = Number(lskRateSettings.lsk_rate ?? 0);
    return cartValue >= lskGreater ? lskPrice : lskRate;
  })();

  useEffect(() => {
    const loadData = async () => {
      try {
        setState((prev) => ({ ...prev, isLoading: true }));
        const zones = await DeliveryService.fetchZones();
        const stores = await DeliveryService.fetchStores();
        const outsideRates = await DeliveryService.fetchOutSideRates();
        setState((prev) => ({
          ...prev,
          zones,
          stores,
          outsideRates,
          isLoading: false,
        }));
        if (userId) {
          dispatch(fetchDeliveryInfo(userId));
        }
      } catch (error) {
        setState((prev) => ({
          ...prev,
          error: error.message,
          isLoading: false,
        }));
      }
    };

    loadData();
  }, [userId, dispatch]);

  useEffect(() => {
    if (savedAddress) {
      setFormData({
        street: savedAddress.street || "",
        fullName: savedAddress.full_name || "",
        contact: savedAddress.contact || "",
        email: savedAddress.email || "",
      });

      setState((prev) => ({
        ...prev,
        deliveryMethod: savedAddress.deliveryMethod || "delivery",
        isEditing: false, // existing info found -> start in read-only/"Edit" mode
        selectedZone:
          savedAddress.deliveryMethod === "delivery" && savedAddress.zone_name
            ? {
                name: savedAddress.zone_name,
                distance: Number(savedAddress.distance) || 0,
                delivery_fee:
                  savedAddress.delivery_fee != null
                    ? Number(savedAddress.delivery_fee)
                    : (Number(savedAddress.distance) || 0) * applicableRate,
              }
            : null,
        selectedStore:
          savedAddress.deliveryMethod === "pickup" && savedAddress.store_name
            ? {
                name: savedAddress.store_name,
                address: savedAddress.store_address,
              }
            : null,
      }));
    } else {
      // no saved address at all -> nothing to edit, so start editable
      setState((prev) => ({ ...prev, isEditing: true }));
    }
  }, [savedAddress, applicableRate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveInfo = async () => {
    try {
      setState((prev) => ({ ...prev, isLoading: true }));

      const payload = {
        full_name: formData.fullName,
        email: formData.email,
        contact: formData.contact,
        user_id: userId,
        deliveryMethod: state.deliveryMethod,
      };

      if (state.deliveryMethod === "delivery") {
        payload.street = formData.street;
        payload.zone_name = state.selectedZone?.name;
        payload.distance = state.selectedZone?.distance
          ? Number(state.selectedZone.distance).toFixed(2)
          : null;
        payload.delivery_fee = state.selectedZone?.delivery_fee
          ? Number(state.selectedZone.delivery_fee).toFixed(2)
          : state.selectedZone?.distance
            ? (Number(state.selectedZone.distance) * 10).toFixed(2)
            : null;
      } else if (state.deliveryMethod === "pickup") {
        payload.store_name = state.selectedStore?.name;
      }

      await DeliveryService.saveDeliveryInfo(payload);
      setState((prev) => ({ ...prev, isEditing: false, isLoading: false }));
      toast.success(
        `${
          state.deliveryMethod === "delivery" ? "Delivery" : "Pickup"
        } information saved successfully!`,
      );
    } catch (error) {
      setState((prev) => ({ ...prev, error: error.message, isLoading: false }));
      toast.error(`Failed to save: ${error.message}`);
    }
  };

  // OPEN INFOR POPUP
  const [isInforOpen, setIsinforOpen] = useState(false);

  const toggleInfor = useCallback(() => {
    setIsinforOpen((prev) => !prev);
  }, []);

  const closeInfor = useCallback(() => {
    setIsinforOpen(false);
  }, []);

  const handleProceedToPayment = () => {
    if (state.deliveryMethod === "delivery" && !state.selectedZone) {
      toast.info("Please select a delivery zone first");
      return;
    }

    if (state.deliveryMethod === "pickup" && !state.selectedStore) {
      toast.info("Please select a store for pickup first");
      return;
    }
    PostHog.capture("Proceed to Payment", {
      property: "Total Amount",
      value: total,
    });
    const paymentDetails = {
      items: checkoutItems.map((item) => ({
        item_name: item.item_name || null,
        item_img: Array.isArray(item.itemPhotos)
          ? item.itemPhotos[0] || "/placeholder-image.jpg"
          : item.itemPhotos || "/placeholder-image.jpg",
        item_price: item.price || item.selectedVariant.price,
        item_color: item.selectedColor?.name || "Any",
        item_variant: item.selectedVariant?.name || null,
        item_qty: item.quantity,
        item_condition: item.condition,
      })),
      user: {
        name: formData.fullName,
        contact: formData.contact,
        user_id: userId,
        email: formData.email,
      },
      deliveryMethod: state.deliveryMethod,
      delivery:
        state.deliveryMethod === "delivery"
          ? {
              zone: state.selectedZone?.name,
              street: formData.street || null,
              distance: state.selectedZone?.distance || null,
            }
          : {
              store: state.selectedStore?.name,
              fee: 0,
            },
      payment: {
        total: total,
        subtotal: totalAmount,
      },
    };

    navigate("/payment", { state: { paymentDetails } });
  };

  const deliveryFee =
    state.deliveryMethod === "delivery"
      ? Number(state.selectedZone?.delivery_fee || 0)
      : 0;

  const toggleDeliveryMethod = (method) => {
    setState((prev) => ({ ...prev, deliveryMethod: method }));
  };

  const calculateTransactionFee = (amount) => {
    const feePercentage = 0.01; // 1% transaction fee
    return amount * feePercentage;
  };

  const total =
    (totalAmount || 0) + deliveryFee + calculateTransactionFee(totalAmount);

  return (
    <div className="checkout-container">
      {isCartOpen && <Cart closeCart={closeCart} closeCartRef={closeCartRef} />}
      <h2>Check out</h2>
      <div className="checkout-grid">
        {/* Delivery Information Card */}
        <div className="card">
          <div className="card-header">
            <div className="flex-title">
              <h3 className="card-title-deli">
                {state.deliveryMethod === "delivery" ? (
                  <FaMapMarkerAlt className="icon" />
                ) : (
                  <FaStore className="icon" />
                )}{" "}
                {state.deliveryMethod === "delivery"
                  ? "Delivery Information"
                  : "Self-Pickup Information"}
              </h3>
              <span>
                <VscDebugBreakpointUnsupported
                  onClick={toggleInfor}
                  size={30}
                  className="icon support"
                />
                <Link to="/Contact">
                  <BiSupport size={25} className="icon support" />
                </Link>
              </span>
            </div>
            {isInforOpen && <Infor closeInfor={closeInfor} />}
          </div>

          <div className="card-content">
            {/* Delivery Method Switcher */}
            <div className="delivery-method-switcher">
              <div
                className={`method-option ${
                  state.deliveryMethod === "delivery" ? "active" : ""
                }`}
                onClick={() => toggleDeliveryMethod("delivery")}
              >
                <FaMapMarkerAlt className="method-icon" />
                <span>Delivery</span>
              </div>
              <div
                className={`method-option ${
                  state.deliveryMethod === "pickup" ? "active" : ""
                }`}
                onClick={() => toggleDeliveryMethod("pickup")}
              >
                <FaStore className="method-icon" />
                <span>Self-Pickup</span>
              </div>
            </div>

            {state.deliveryMethod === "delivery" ? (
              // Delivery Information Form
              <>
                <ZoneDropdown
                  zones={state.zones}
                  selectedZone={state.selectedZone}
                  onSelect={(zone) =>
                    setState((prev) => ({ ...prev, selectedZone: zone }))
                  }
                  isEditing={state.isEditing}
                  cartValue={cartValue}
                  applicableRate={applicableRate}
                  state={state}
                />

                <div className="toggle-row">
                  {state.isLoading ? (
                    <div className="loading">
                      <Loader />
                    </div>
                  ) : (
                    <span>
                      {" "}
                      out of lusaka rates depend on the cart value and
                      Distance{" "}
                    </span>
                  )}
                </div>

                <div className="input-group">
                  <input
                    type="text"
                    className="input"
                    placeholder="Street address"
                    name="street"
                    value={formData.street}
                    onChange={handleInputChange}
                    disabled={!state.isEditing}
                    required
                  />
                </div>
              </>
            ) : (
              // Self-Pickup Information Form
              <StoreDropdown
                stores={state.stores}
                selectedStore={state.selectedStore}
                onSelect={(store) =>
                  setState((prev) => ({ ...prev, selectedStore: store }))
                }
                isEditing={state.isEditing}
              />
            )}

            {/* Common fields for both methods */}
            <div className="input-row">
              <input
                type="text"
                className="input"
                placeholder="Full Name"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                disabled={!state.isEditing}
                required
              />
              <input
                type="tel"
                className="input"
                placeholder="Contact Number"
                name="contact"
                value={formData.contact}
                disabled={!state.isEditing}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="email"
                className="input"
                placeholder="Email address"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                disabled={!state.isEditing}
                required
              />
            </div>

            <button
              className="proceed-button"
              onClick={
                state.isEditing
                  ? handleSaveInfo
                  : () => setState((prev) => ({ ...prev, isEditing: true }))
              }
            >
              {state.deliveryMethod === "delivery" ? (
                <FaMapMarkerAlt className="icon" />
              ) : (
                <FaStore className="icon" />
              )}
              {state.isEditing
                ? state.deliveryMethod === "delivery"
                  ? "Save Delivery Information"
                  : "Save Pickup Information"
                : state.deliveryMethod === "delivery"
                  ? "Edit Delivery Information"
                  : "Edit Pickup Information"}
            </button>
          </div>
        </div>

        {/* Cart Summary Card */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">
              <FaShoppingBag className="icon" /> Cart Summary
            </h3>
          </div>

          <div className="card-content">
            <div className="cart-items">
              {checkoutItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <div className="item-image">
                    <img
                      src={
                        Array.isArray(item.itemPhotos)
                          ? item.itemPhotos[0] || "/placeholder-image.jpg"
                          : item.itemPhotos || "/placeholder-image.jpg"
                      }
                      alt={item.item_name || "Unnamed Item"}
                      className="product-image"
                    />
                  </div>
                  <div className="item-info">
                    <p className="item-name">{item.item_name}</p>
                    <p className="item-name">
                      {item.selectedColor?.name || "Any"}
                    </p>
                    <p className="item-name">
                      {item.selectedVariant?.name || "Any"}
                    </p>
                    <p className="item-quantity">Quantity: {item.quantity}</p>
                  </div>
                  <p className="item-price">
                    K{" "}
                    {item.price * item.quantity?.toLocaleString() ||
                      item.selectedVariant.price *
                        item.quantity?.toLocaleString()}
                  </p>
                </div>
              ))}
            </div>

            <div className="summary">
              <div className="summary-row">
                <span>Sub-Total</span>
                <span>
                  K {totalAmount?.toFixed(2).toLocaleString() || "0.00"}
                </span>
              </div>
              <div className="summary-row">
                <span>Transaction Fee</span>
                <span>
                  K{" "}
                  {calculateTransactionFee(totalAmount)
                    ?.toFixed(2)
                    .toLocaleString() || "0.00"}
                </span>
              </div>
              <div className="summary-row">
                <span>
                  {state.deliveryMethod === "delivery"
                    ? "Delivery Fee"
                    : "Pickup Fee"}
                </span>
                <span>K {deliveryFee.toFixed(2).toLocaleString()}</span>
              </div>
              <div className="summary-row total">
                <span>Total</span>
                <span>K {total.toFixed(2).toLocaleString()}</span>
              </div>
            </div>

            <button className="proceed-button" onClick={handleProceedToPayment}>
              <FaCreditCard className="icon" /> Proceed to Payment
            </button>
            <ToastContainer position="top-center" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
